import BottomSheet from '../BottomSheet';

/**
 * Окна геолокации на прогулке: свой вопрос до системного и инструкция,
 * когда позиции нет. Состояние — из `useWalkGeolocation`
 */
const GeoModals = ({ geo }) => {
  const {
    showGeoPromptModal, setShowGeoPromptModal, acceptPrompt, declinePrompt,
    showGeoAccessModal, setShowGeoAccessModal, geoErrorKind, geoRetrying, handleGeoRetry,
  } = geo;

  return (
    <>
      <BottomSheet
        isOpen={showGeoPromptModal}
        onClose={() => setShowGeoPromptModal(false)}
        title="Поделитесь геолокацией"
        footer={
          <div className="flex gap-2">
            <button
              onClick={acceptPrompt}
              className="flex-[2] h-12 rounded-md text-label bg-action text-on-action border-0 transition-colors duration-fast ease-out active:scale-98"
            >
              Разрешить
            </button>
            <button
              onClick={declinePrompt}
              className="flex-1 h-12 rounded-md text-label transition-colors duration-fast ease-out active:scale-98"
              style={{
                background: 'var(--color-card-secondary)',
                color: 'var(--color-text-secondary)',
              }}
            >
              Пропустить
            </button>
          </div>
        }
      >
        {/* Раньше обещали «автоматически отмечать посещённые точки» —
            такой функции нет, отметка только кнопкой */}
        <p className="text-body text-theme-text-secondary">
          Покажем вас на карте и посчитаем, сколько идти до следующего места.
        </p>
      </BottomSheet>

      {/* Нет геолокации. Причины разные, инструкции тоже: запрет доступа
          и выключенная на телефоне геолокация чинятся в разных местах */}
      <BottomSheet
        isOpen={showGeoAccessModal}
        onClose={() => setShowGeoAccessModal(false)}
        title={
          geoErrorKind === 'unavailable'
            ? 'Не удалось определить место'
            : geoErrorKind === 'unsupported'
              ? 'Устройство не поддерживает геолокацию'
              : 'Нет доступа к геолокации'
        }
        footer={
          geoErrorKind === 'unsupported' ? (
            <button
              onClick={() => setShowGeoAccessModal(false)}
              className="w-full h-12 rounded-md text-label bg-action text-on-action border-0 transition-colors duration-fast ease-out active:scale-98"
            >
              Понятно
            </button>
          ) : (
            <div className="flex gap-2">
              <button
                onClick={() => setShowGeoAccessModal(false)}
                className="flex-1 h-12 rounded-md text-label transition-colors duration-fast ease-out active:scale-98"
                style={{
                  background: 'var(--color-card-secondary)',
                  color: 'var(--color-text-secondary)',
                }}
              >
                Закрыть
              </button>
              {/* Без этой кнопки инструкцию некуда применить: человек
                  чинит настройки и должен тут же проверить результат */}
              <button
                onClick={handleGeoRetry}
                disabled={geoRetrying}
                className="flex-[2] h-12 rounded-md text-label bg-action text-on-action border-0 transition-colors duration-fast ease-out active:scale-98"
                style={{ opacity: geoRetrying ? 0.6 : 1 }}
              >
                {geoRetrying ? 'Проверяем…' : 'Попробовать снова'}
              </button>
            </div>
          )
        }
      >
        {geoErrorKind === 'unsupported' ? (
          <p className="text-body-sm text-theme-text-secondary">
            Браузер или устройство не умеет определять местоположение. Маршрут
            можно пройти и без него — расстояние до мест показываться не будет.
          </p>
        ) : (
          <>
            <p className="text-body-sm text-theme-text-secondary mb-3">
              {geoErrorKind === 'unavailable'
                ? 'Похоже, на телефоне выключены службы геолокации. Включите их и вернитесь:'
                : geoErrorKind === 'denied'
                  ? 'Доступ запрещён. Его можно вернуть в настройках телефона:'
                  : 'Проверьте две вещи — обычно дело в одной из них:'}
            </p>

            {/* Случай 1: геолокация выключена на самом телефоне */}
            {(geoErrorKind === 'unavailable' || geoErrorKind === 'unknown') && (
              <div className="mb-4">
                {/* Заголовок нужен, только когда причин показано две:
                    иначе он повторяет строку выше */}
                {geoErrorKind === 'unknown' && (
                  <p className="text-body-sm text-theme-text-primary font-semibold mb-1">
                    Службы геолокации выключены на телефоне
                  </p>
                )}
                <ol className="text-body-sm text-theme-text-secondary list-decimal pl-5 space-y-1">
                  <li>
                    <strong className="text-theme-text-primary">iPhone:</strong> Настройки →
                    Конфиденциальность и безопасность → Службы геолокации
                  </li>
                  <li>
                    <strong className="text-theme-text-primary">Android:</strong> Настройки →
                    Местоположение
                  </li>
                  <li>Включите переключатель и вернитесь сюда</li>
                </ol>
              </div>
            )}

            {/* Случай 2: доступ запрещён именно Telegram — частая ошибка,
                когда запрос отклонили не глядя */}
            {(geoErrorKind === 'denied' || geoErrorKind === 'unknown') && (
              <div>
                {geoErrorKind === 'unknown' && (
                  <p className="text-body-sm text-theme-text-primary font-semibold mb-1">
                    Telegram запрещён доступ к геолокации
                  </p>
                )}
                <ol className="text-body-sm text-theme-text-secondary list-decimal pl-5 space-y-1">
                  <li>Откройте настройки телефона</li>
                  <li>
                    <strong className="text-theme-text-primary">iPhone:</strong> Настройки →
                    Telegram → Геопозиция → «При использовании»
                  </li>
                  <li>
                    <strong className="text-theme-text-primary">Android:</strong> Настройки →
                    Приложения → Telegram → Разрешения → Местоположение
                  </li>
                  <li>Вернитесь сюда и проверьте</li>
                </ol>
              </div>
            )}
          </>
        )}
      </BottomSheet>
    </>
  );
};

export default GeoModals;
